import '../IncrementalityPlaybook.scss';
import { IncPlaybookSectionBox } from '../IncrementalityPlaybookShared';
import { playbookData, playbookTable } from '../PlaybookTable';

const PAGE_TITLE = 'Commerce';

export const Commerce = () => (
  <div className='inc-playbook-page'>
    <IncPlaybookSectionBox
      content={
        <div className='main-table'>
          {playbookTable(playbookData.filter(row => row.Channel[0].value === 'ConnectedCommerce'))}
        </div>
      }
      pageTitle={PAGE_TITLE}
      title='Incrementality Testing Approaches'
    />
  </div>
);
